import { type StateCreator } from 'zustand';
import { SortingOptionId } from '@pkgs/components/enums/enums';
import { type CoordinateDto } from '@ev-tech/search-modules-api';

import { type MiddlewareType, type SearchStore } from '../SearchStoreProvider';

export type OptionsState = {
  page: number;
  pageSize: number;
  sortingOptionId: SortingOptionId;
  sortByDistanceToPoint?: CoordinateDto;
};

type OptionsActions = {
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  setSortingOptionById: (sortOptionId: SortingOptionId) => void;
  setSortByDistanceToPoint: (sortByDistanceToPoint: CoordinateDto) => void;
};

export type OptionsStore = OptionsState & OptionsActions;

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 23;
export const DEFAULT_SORTING_OPTION_ID = SortingOptionId.PRICE_DESC;

export const defaultOptionsState: Readonly<OptionsState> = {
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
  sortingOptionId: DEFAULT_SORTING_OPTION_ID,
};

export const createOptionsSlice: StateCreator<SearchStore, MiddlewareType, [], OptionsStore> = (set) => {
  return {
    ...defaultOptionsState,
    setPage: (page: number) => set({ page }, undefined, 'setPage'),
    setPageSize: (pageSize: number) => set({ pageSize }, undefined, 'setPageSize'),
    setSortingOptionById: (sortingOptionId: SortingOptionId) => {
      set({ page: 1, sortingOptionId }, undefined, 'setSortingOptionById');
    },
    setSortByDistanceToPoint: (sortByDistanceToPoint: CoordinateDto) =>
      set({ sortByDistanceToPoint }, undefined, 'setSortByDistanceToPoint'),
  };
};
